import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "image-item"
};
const _hoisted_2 = {
  class: "image-item-name"
};
import { computed, onMounted, reactive, toRefs } from 'vue';
export default {
  __name: 'ImageItem',
  props: {
    name: {
      type: String
    },
    url: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    const {
      name,
      url
    } = toRefs(props);
    // const data = reactive({
    //   imgName: '',
    //   imgUrl: ''
    // })
    //
    // onMounted(() => {
    //   data.imgName = props.name
    //   data.imgUrl = props.url + '_s'
    // })
    const previewSrcList = computed(() => {
      console.info("prop url" + url.value);
      if (url.value) {
        return [url.value];
      }
      return [];
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_image, {
        src: _unref(url),
        "preview-src-list": previewSrcList.value
      }, null, 8, ["src", "preview-src-list"]), _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(name)), 1)]);
    };
  }
};